<script>
	// import Cube from "./Perlin1.svelte";
	// import Perlin1 from "./Perlin1.svelte";
	// import Perlin2 from "./Perlin2.svelte";
	// import Perlin3 from "./Perlin3.svelte";
	// import Perlin4 from "./Perlin4.svelte";
	// import Perlin5 from "./Perlin5.svelte";
	// import Perlin6 from "./Perlin6.svelte";
	// import Perlin7 from "./Perlin7.svelte";
	// import PerlinXXX from "./PerlinXXX.svelte";
	// import PerlinXXXV2 from "./PerlinXXXV2.svelte";
	import PerlinProd from "./PerlinProd.svelte";
	
	// import PerlinXXX from "./PerlinXXX-loop.svelte";
	// import Oval1 from "./Oval-1.svelte";
	// import Oval2 from "./Oval-2.svelte";
	export let name
	console.log('==> name', name)
</script>

<main>
	<!-- <Perlin1 /> -->
	<!-- <Perlin2 /> -->
	<!-- <Perlin3 /> -->
	<!-- <Perlin4 /> -->
	<!-- <Perlin5 /> -->
	<!-- <Perlin6 /> -->
	<!-- <Perlin7 /> -->
	<!-- <PerlinXXX V2/> -->
	<!-- <PerlinXXXV2/> -->
	<PerlinProd />
	<!-- <Oval1 /> -->
	<!-- <Oval2 /> -->
</main>
